module.exports = __webpack_public_path__ + "img/c00_buildingtechirrigation_Normal_ua.3acc59ae.webp";